import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ConfirmDialog } from '@/shared/ui/confirm-dialog'
import { Switch } from '@/shared/ui/switch'

export interface StatusToggleWithConfirmProps {
  checked: boolean
  disabled?: boolean
  pending?: boolean
  /** Shown when `checked` is false — user is about to enable */
  confirmEnableTitle: string
  /** Shown when `checked` is true — user is about to disable */
  confirmDisableTitle: string
  onConfirmed: () => void | Promise<void>
}

// * VI: Switch + hộp thoại xác nhận giống cột status tenant. | EN: Switch + confirm dialog pattern used for tenant status column.
export function StatusToggleWithConfirm({
  checked,
  disabled,
  pending,
  confirmEnableTitle,
  confirmDisableTitle,
  onConfirmed,
}: StatusToggleWithConfirmProps) {
  const { t } = useTranslation()
  const [showConfirm, setShowConfirm] = useState(false)

  return (
    <span onClick={(e) => e.stopPropagation()} className="inline-flex">
      <Switch
        checked={checked}
        disabled={!!pending || !!disabled}
        onCheckedChange={() => setShowConfirm(true)}
      />
      <ConfirmDialog
        open={showConfirm}
        title={checked ? confirmDisableTitle : confirmEnableTitle}
        confirmLabel={t('common.confirm')}
        cancelLabel={t('common.cancel')}
        onConfirm={() => {
          setShowConfirm(false)
          void onConfirmed()
        }}
        onCancel={() => setShowConfirm(false)}
      />
    </span>
  )
}
